import { CSSResultGroup, html, LitElement } from 'lit'
import { classMap } from 'lit/directives/class-map.js'
import { customElement, property } from 'lit/decorators.js'

import { style } from './password-check.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'

export interface CheckResults {
  length_error: boolean
  digit_error: boolean
  symbol_error: boolean
  uppercase_error: boolean
  lowercase_error: boolean
}

const CheckResultsDefault: CheckResults = {
  length_error: false,
  digit_error: false,
  symbol_error: false,
  uppercase_error: false,
  lowercase_error: false,
}

export interface Messages {
  length: string
  digit: string
  symbol: string
  uppercase: string
  lowercase: string
}

export const MessagesDefault = {
  length: 'Password length error',
  digit: 'Password digits error',
  symbol: 'Password symbol error',
  uppercase: 'Password uppercase error',
  lowercase: 'Password lowercase error',
}

@customElement('csc-password-check')
export class CSCPasswordCheck extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, style]

  @property({
    type: Object,
    converter: {
      fromAttribute(value): CheckResults {
        if (value && value.length > 0) {
          return JSON.parse(decodeURI(value))
        }

        return CheckResultsDefault
      }
    }
  })
  results: CheckResults = CheckResultsDefault

  @property({
    type: Object,
    converter: {
      fromAttribute(value): Messages {
        if (value && value.length > 0) {
          return JSON.parse(decodeURI(value))
        }

        return MessagesDefault
      }
    }
  })
  messages: Messages = MessagesDefault

  _hasErrors() {
    let has_error = false

    if (this.results.length_error) {
      has_error = true
    }
    if (this.results.digit_error) {
      has_error = true
    }
    if (this.results.symbol_error) {
      has_error = true
    }
    if (this.results.uppercase_error) {
      has_error = true
    }
    if (this.results.lowercase_error) {
      has_error = true
    }

    return has_error
  }

  override render() {
    const classes = {
      'csc-password-check': true,
      'has-errors': this._hasErrors()
    }

    return html`
      <div class=${classMap(classes)}>
        <cse-alert variant="warning">
          ${this.results.length_error ? html`<div>${this.messages.length}</div>` : null}
          ${this.results.digit_error ? html`<div>${this.messages.digit}</div>` : null}
          ${this.results.symbol_error ? html`<div>${this.messages.symbol}</div>` : null}
          ${this.results.uppercase_error ? html`<div>${this.messages.uppercase}</div>` : null}
          ${this.results.lowercase_error ? html`<div>${this.messages.lowercase}</div>` : null}
        </cse-alert>
      </div>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'csc-password-check': CSCPasswordCheck,
  }
}
